
/*eslint-disable import/prefer-default-export*/
export const toCurrency = (value = 0, prefix = '£') => {
  const minus = value < 0 ? '- ' : '';
  const abs = Math.abs(value || 0);
  const result = `${minus}${prefix}${parseFloat(abs).toFixed(2)}`;
  return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default toCurrency;



// WEBPACK FOOTER //
// ./src/services/Convert/toCurrency.js